import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-research-studies-detail',
  standalone: true,
  imports: [CommonModule, ModalModule, BreadcrumbComponent],
  templateUrl: './research-studies-detail.component.html',
  styleUrl: './research-studies-detail.component.scss'
})
export class ResearchStudiesDetailComponent {
  @Input() researchStudyData: any;
  @Input() parentPage: string = 'Research Studies';
  @Output() modalClosed = new EventEmitter<void>();

  constructor(
    public modalRef: BsModalRef,
    private cdr: ChangeDetectorRef
  ) {}

  get breadcrumbItems(): Array<{ label: string }> {
    return [
      { label: 'Dashboard' },
      { label: this.parentPage || 'Research Studies' },
      { label: this.researchStudyData?.study_name || 'Detail' }
    ];
  }

  get whoCanJoinItems(): string[] {
    const whoCanJoin = this.researchStudyData?.who_can_join;
    if (!whoCanJoin) return [];
    if (Array.isArray(whoCanJoin)) return whoCanJoin;
    return String(whoCanJoin)
      .split(',')
      .map((item) => item.trim())
      .filter((item) => !!item);
  }

  get completionDocumentNames(): string[] {
    const completionConfig = this.researchStudyData?.completion_config;
    const documents = completionConfig?.['documents'];
    if (!Array.isArray(documents)) return [];
    return documents
      .map((document: any) => document?.name)
      .filter((name: string | undefined) => !!name);
  }

  closeModal(): void {
    this.modalClosed.emit();
    this.modalRef.hide();
    this.cdr.detectChanges();
  }
}
